import { Injector } from "@angular/core";
import { ServiceEnum } from "../../../ServiceEnum";
import { EntityEnum } from "../../EntityEnum";
import { DummyNode } from "../../DummyNode";
import { TreeNodeReportingNameEntity } from "../Entity/TreeNodeReportingNameEntity";
import { MedicinalproductsService } from "../../../../service/medicinalproducts-service/medicinalproducts.service";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";
import { BaseNode } from "../../BaseNode";
import { OnDemandAutoUploadList } from "./OnDemandAutouploadList";


export class TreeNodeMedicinalProductsReportingName extends OnDemandAutoUploadList{
    id: any;
    entity: any;
    useHist: boolean = false;
    constructor(injector: Injector, id: number, entity: EntityEnum, parent: any, useHist: boolean, disableAutoUpload: boolean, cloningNode: boolean) {
        super(injector,
             entity==EntityEnum.presentationName?"Reporting Names - Presentation":"Reporting Names - Scientific",
             ["Product Index EV Code","Name","Name Type","Created (When)","Nullified","Status","Is a Full Presentation","Linked to a CAP","Linked to a Substance", "Show in Lookup", "Num Products (Presentations)", "Num Products (Scientific)"],
             ServiceEnum.MedicinalProducts,
             `pk_product:eq:${id}`,
             TreeNodeReportingNameEntity,
             entity, disableAutoUpload, cloningNode);
             this.parent = parent;
             this.id = id;
             this.entity = entity;
             this.entity == 'presentationName' ? this.labelNodeName = "Reporting Names - Presentation" : this.labelNodeName = "Reporting Names - Scientific";

             this.useHist = useHist;
             if (this.cloningNode) {
                return;
             }
             this.children?.push(new DummyNode());
    }

    override postLoad(model: any[]) {

        for (const item of model) {
            this.children?.push(new this.entityClass!(this.ioc, `${item.productnamevariation}`, this, item));
        }
        const numItems: string = model && model.length > 0?model.length.toString():'-'; 
        this.label = this.labelTemplate + ' (' + numItems + ')';
        this.refreshLabel();
    }

    override load() {

      let service: any;
        switch (this.service) {
            case ServiceEnum.MedicinalProducts:
                service = this.ioc!.get(MedicinalproductsService);
                break;
        }

        if (this.isLoaded) {
            return;
        }

        if (this.disableAutoUpload) {
            this.children?.splice(0, this.children.length); // remove dummy node
            this.data = new this.entityClass!(this.ioc!, this.labelTemplate, this, this.data.model);
            if (!this.cloningNode){
                this.postLoad(this.dataSource);
            }
            this.isLoaded = true;
        } else {        
            this.children?.splice(0, this.children.length); // remove dummy node
            service.getAll(this,this.autoUploadEntityName, this.criteria)
                .subscribe({
                    next: (data: any) => {
                        const jsonData = data.result;
                        const filteredData = this.filterResult(data.result);
                        if (filteredData) {
                            this.dataSource = jsonData;
                            this.postLoad(filteredData);
                            this.isLoaded = true;
                        } else {
                            this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'No results found', life: environment.warningElapsedTime });
                        }
                    },
                    error: (error: any) => {
                        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                    }
                });
        }
    }
    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsReportingName = new TreeNodeMedicinalProductsReportingName(
        this.ioc!,
        this.id,
        this.entity,
        newParent,
        false,
        this.isLoaded,
        true
      );
      
      clonedNode.data.model = JSON.stringify(this.data.model);
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
      
      clonedNode.cloningNode = false;
      return clonedNode;
    }

    override getOnDemandEntities() {
        let entitiesArray:any[] = super.getOnDemandEntities();
        // check if not empy array then set the name for JSON
        if(entitiesArray.length>0) {
            switch (this.entity)
            {
                case EntityEnum.presentationName:
                    return {presentationnames:{reportingnames: entitiesArray} }
                case EntityEnum.scientificName:
                    return {scientificnames:{reportingnames: entitiesArray} }
            }   
            
        }
        return {};
    }
}